import { useTranslation } from 'react-i18next';

import * as St from './SlabViewerTrendPreview.styles';

import { imgUrl } from '~/core/utils';

interface SlabViewerTrendPreviewProps {
  slabPreviewURL: string;
  trendLabel?: string;
}

const SlabViewerTrendPreview = ({
  trendLabel,
  slabPreviewURL,
}: SlabViewerTrendPreviewProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <St.PreviewContainer>
      {trendLabel && (
        <St.TrendBadge>{t(trendLabel).toUpperCase()}</St.TrendBadge>
      )}
      <St.PreviewImage src={imgUrl(slabPreviewURL, 2400)} />
    </St.PreviewContainer>
  );
};

export default SlabViewerTrendPreview;
